import { VODCSSModules } from 'shared/utils/wix-connect';
import { ChannelSubscriptionBase } from './channel-subscription';
import styles from './channel-subscription-mobile.styl';


export default VODCSSModules(styles)(ChannelSubscriptionBase);



// WEBPACK FOOTER //
// ./src/widget/components/payments/channel-subscription-mobile.js